module.exports = __webpack_public_path__ + "img/slogan.ea54da4f.png";